import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { Client } from '../models/client.model';

@Injectable()
export class ClientService {

    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/Client/";
    }

    async getClients(): Promise<Client[]> {
        return await this._http.get<Client[]>(`${this.apiServer}GetClients`).toPromise<Client[]>();
    }
    async GetClientById()
    {
      return await this._http.get<Client>(`${this.apiServer}GetClientById`).toPromise<Client>();
    }
    async UpdateClientConfiguration(client:Client):Promise<number>
    {
      return await this._http.post<number>(`${this.apiServer}UpdateClientConfiguration`, JSON.stringify(client)).toPromise<number>();
    }
    async GetshiftLeadersCount(defaultReportAccesstoShiftLeaders:boolean, clientId: number):Promise<number>
    {
      const params = new HttpParams()
          .set('isDefaultReportAccessToshiftLeaders', defaultReportAccesstoShiftLeaders.toString())
          .set('clientId', clientId.toString());
          
      return await this._http.get<number>(`${this.apiServer}GetShiftLeadersCount`, { params: params }).toPromise<number>();
    }
}